<template>
	<div class="car-about-us">
	  	<van-row>
		  	<van-col class="title" span="24"><img src="../../assets/car/border.png" />销巴汽车</van-col>
		  	<van-col class="littletitle" span="24">主营业务</van-col>
		  	<van-col class="con" span="24">销巴汽车是销巴集团重点打造的汽车新零售业务，销巴汽车于2017年年底正式上线销售，已经有200个汽车品牌，8,000多款全新车型在售，还包括二手车、新能源车型、各类大型车辆均可以参与“购车享补贴”的销售模式，为您节省购车成本，目前已得到全国广大用户的认可和信赖。</van-col>
			<van-col class="con" span="24">销巴汽车坚持走刚需路线，以真实购车消费、绿色正规、合法经营为发展基础，正在逐步发展成为中国汽车行业新零售创新模式的标杆型品牌企业。</van-col>
			<van-col class="model" span="24">
				<img src="../../assets/car/address.png" />
				<p>浙江省杭州市江干区解放东路33号财富金融中心西楼3F</p>
			</van-col>
			<van-col class="model" span="24">
				<img src="../../assets/car/telphone.png" />
				<p><a href="tel:057187708286" class="call" @click="iOStel('057187708286')">057187708286</a></p>
				<p><a href="tel:4000571671" class="call" @click="iOStel('4000571671')">4000571671</a></p>
			</van-col>
	  		
	  	</van-row>
	</div>
</template>

<script>
export default {
	data() {
	    return {
	     	ua: ''
	    };
	},
	created(){
	　　	this.ua = navigator.userAgent.toLowerCase();
	},
	methods: {
	    iOStel(tel){
			if (/iphone|ipad|ipod|macintosh/i.test(this.ua)) {
				localStorage.setItem("Phone", tel);
		        this.show();
		    }
		},
		show(){
			var tel = localStorage.getItem("Phone");
			window.webkit.messageHandlers.show.postMessage(tel);
		}
	}
};
</script>

<style lang="less">
.car-about-us {
	height: 100%;
	background: #fff;
	color: #666;
	.van-row {
		padding: 0 16px;
		.title {
			height: 59px;
			line-height: 59px;
			font-size: 18px;
			color: #333;
			font-weight: 700;
			img {
				width: 4px;
				float: left;
				margin: 19px 9px 0 0;
			}
		}
		.littletitle {
			color: #333;
			font-size: 15px;
			height: 21px;
			line-height: 21px;
			margin-bottom: 9px;
			font-weight: 700;
		}
		.con {
			font-size: 15px;
			line-height: 21px;
			padding-bottom: 4px;
		}
		.model {
			border-radius: 4px;
			padding: 12px 15px;
			margin-top: 20px;
			background: -webkit-linear-gradient(to right, rgba(245, 246, 247, 1), rgba(245, 246, 247, 0)); /* Safari 5.1 - 6.0 */
		    background: -o-linear-gradient(to right, rgba(245, 246, 247, 1), rgba(245, 246, 247, 0)); /* Opera 11.1 - 12.0 */
		    background: -moz-linear-gradient(to right, rgba(245, 246, 247, 1), rgba(245, 246, 247, 0)); /* Firefox 3.6 - 15 */
		    background: linear-gradient(to right, rgba(245, 246, 247, 1), rgba(245, 246, 247, 0)); /* 标准的语法（必须放在最后） */
		    p {
			   	padding-left: 30px;
			   	line-height: 24px;
			   	font-size: 14px;
			   	.call {
			   		color: #666;
			   	}
		    }
		    img {
			   		width: 20px;
			   		float: left;
			   		margin-top: 14px;
		   	}
		   
		}
	}
}

</style>
